import React from "react";
import { PageHeader } from "../../../components";

export default function MEMBERSHIPSECRETARY() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_MEMBERSHIP_SEC.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">Francis Ofordu</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                 Francis Ofordu is a long-standing member of Lagos Country Club since 2013 and currently serves as Membership Secretary. A seasoned banking professional with over 18 years of experience, he is passionate about enhancing member engagement, upholding club standards, and driving service excellence.

He has previously served in various Club committees, including as Secretary of the Other Games Section and member of the Secretary & Staff Matters Committee. Francis holds an MBA from Lagos State University and is an alumnus of Lagos Business School's Senior Management Programme. He is married with two children. 
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
